module.exports = __webpack_public_path__ + "img/icon_map_32_on_011.3a87d1f2.png";